module.exports = __webpack_public_path__ + "media/30_Long.decd532b.mp3";